export default (state = [], { type, payload }) => {
  if (type === 'GREENMILE_ROUTEMONITOR_PENDING_ORDERS_SUCCESS') {
    return payload;
  }
  return state;
};
